(() => {
  const SELECTORS = {
    content: '.product-popup-modal__content-info',
    modal: '.product-popup-modal--size-chart',
    table: '.product-popup-modal__content-info table',
  };

  const getCellText = (cell) => cell.textContent.replace(/\s+/g, ' ').trim();
  const normalizeText = (value) => value.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();

  const createElement = (tagName, className, textContent) => {
    const element = document.createElement(tagName);
    element.className = className;
    if (textContent) element.textContent = textContent;
    return element;
  };

  const enhanceTable = (table, tableIndex) => {
    if (table.dataset.sizeChartEnhanced === 'true') return;

    const rows = Array.from(table.rows);
    const headerRow = table.tHead?.rows[0] || rows[0];
    const headers = headerRow ? Array.from(headerRow.cells, getCellText) : [];
    const measurementRows = rows.filter((row) => row !== headerRow && row.cells.length > 1);

    if (headers.length < 2 || measurementRows.length < 1 || headers.some((header) => !header)) return;

    table.dataset.sizeChartEnhanced = 'true';
    table.classList.add('size-chart-modal__source-table');

    const picker = createElement('section', 'size-chart-mobile-picker');
    picker.setAttribute('aria-label', table.getAttribute('aria-label') || headers[0]);

    const label = createElement('p', 'size-chart-mobile-picker__label', headers[0]);
    const options = createElement('div', 'size-chart-mobile-picker__options');
    const panel = createElement('div', 'size-chart-mobile-picker__panel');
    const panelId = `SizeChartPanel-${tableIndex}`;
    panel.id = panelId;
    panel.setAttribute('aria-live', 'polite');

    const updatePanel = (selectedRow, selectedButton) => {
      options.querySelectorAll('button').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === selectedButton));
      });

      panel.replaceChildren();

      const cells = Array.from(selectedRow.cells);
      panel.appendChild(createElement('p', 'size-chart-mobile-picker__selected-size', getCellText(cells[0])));

      const measurements = createElement('dl', 'size-chart-mobile-picker__measurements');
      cells.slice(1).forEach((cell, cellIndex) => {
        const measurement = createElement('div', 'size-chart-mobile-picker__measurement');
        measurement.appendChild(createElement('dt', '', headers[cellIndex + 1]));
        measurement.appendChild(createElement('dd', '', getCellText(cell)));
        measurements.appendChild(measurement);
      });
      panel.appendChild(measurements);
    };

    measurementRows.forEach((row, rowIndex) => {
      const button = createElement(
        'button',
        'size-chart-mobile-picker__option',
        getCellText(row.cells[0])
      );
      button.type = 'button';
      button.setAttribute('aria-controls', panelId);
      button.setAttribute('aria-pressed', String(rowIndex === 0));
      button.addEventListener('click', () => updatePanel(row, button));
      options.appendChild(button);
    });

    picker.append(label, options, panel);
    table.insertAdjacentElement('afterend', picker);
    updatePanel(measurementRows[0], options.querySelector('button'));
  };

  const markSectionHeadings = (modal) => {
    modal.querySelectorAll(`${SELECTORS.content} h2, ${SELECTORS.content} h3, ${SELECTORS.content} h4, ${SELECTORS.content} p`).forEach((element) => {
      if (normalizeText(element.textContent) === 'how to measure') {
        element.classList.add('size-chart-modal__section-heading');
      }
    });
  };

  const initialize = (root = document) => {
    root.querySelectorAll(SELECTORS.modal).forEach((modal, modalIndex) => {
      markSectionHeadings(modal);
      modal.querySelectorAll(SELECTORS.table).forEach((table, tableIndex) => {
        enhanceTable(table, `${modalIndex}-${tableIndex}`);
      });
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', () => initialize());
})();
